export default __webpack_public_path__ + "static/cn2-48c54869eea5fa9c9220ef39ca44dd28.png";